const TERMINAL_SAFE_DEPOSIT_BOX_STATUSES = ['INACTIVE', 'WITHDRAWN'];

/** Statuses a box can only reach by having been active, for rows written before `activeSince` was stamped. */
const ACTIVATED_SAFE_DEPOSIT_BOX_STATUSES = ['ACTIVE', 'IN_CLOSING', ...TERMINAL_SAFE_DEPOSIT_BOX_STATUSES];

export const isTerminalSafeDepositBoxStatus = (agreementStatus: string | undefined) =>
  TERMINAL_SAFE_DEPOSIT_BOX_STATUSES.includes(agreementStatus ?? '');

/**
 * Mirrors the backend lock: safe location, safe size and safe number are frozen once the box has been
 * activated, because they describe a physical safe that CRMCH has already handed over.
 */
export const areSafeDepositBoxDetailsLocked = (agreement: { activeSince?: Date; agreementStatus?: string }): boolean =>
  !!agreement.activeSince || ACTIVATED_SAFE_DEPOSIT_BOX_STATUSES.includes(agreement.agreementStatus ?? '');
